import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroV2 from "./components/HeroV2";
import StudentChallenges from "./components/StudentChallenges";
import ProcessTimeline from "./components/ProcessTimeline";
import ServicesV2 from "./components/ServicesV2";
import CountriesV2 from "./components/CountriesV2";
import TrustSection from "./components/TrustSection";
import TestimonialsV2 from "./components/TestimonialsV2";
import ConsultationForm from "./components/ConsultationForm";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppWidget from "./components/WhatsAppWidget";
import LeadCapturePopup from "./components/LeadCapturePopup";
import AdminDashboard from "./components/AdminDashboard";
import SocialProofNotification from "./components/SocialProofNotification";
import UrgencyBanner from "./components/UrgencyBanner";
import TrustBadges from "./components/TrustBadges";
import About from "./components/About";
import { Toaster } from "./components/ui/sonner";

const HomePage = () => (
  <>
    <UrgencyBanner />
    <Header />
    <HeroV2 />
    <TrustBadges />
    <StudentChallenges />
    <ProcessTimeline />
    <ServicesV2 />
  <CountriesV2 />
    <TrustSection />
    <TestimonialsV2 />
    <ConsultationForm />
    <FAQ />
    <Contact />
    <Footer />
    <WhatsAppWidget />
    <LeadCapturePopup />
    <SocialProofNotification />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
    <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
